/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * The period of the contract
 * @nullable
 */
export enum PatchContractDTOPeriod {
  NUMBER_24= '24',
  NUMBER_36= '36',
  NUMBER_48= '48',
  NUMBER_60= '60',
  NUMBER_72= '72',
  NUMBER_84= '84',
  indefinite= 'indefinite',
  null= null,

}